import { BaseError } from 'make-error';

/**
 * Represents an error when an Element detached from the DOM is referenced.
 */
export class DetachedDomElementError extends BaseError {
    constructor(message?: string) {
        super(message);
    }
}

export class VideoLoadError extends BaseError {
    constructor(message?: string) {
        super(message);
    }
}
